<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="default"></ion-back-button>
    </ion-buttons>
    <ion-title *ngIf="isFav">Saved Recipes</ion-title>
    <ion-title *ngIf="!isFav">Browse Recipes</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div class="ion-text-center ion-padding" *ngIf="!isLoading && loadedRecipes.length===0 && isFav">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-img src="../../../assets/images/MimboLogo.png" class="logo"></ion-img>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-text color="darkmimbo">You have not saved any recipes yet. <br />
    </ion-text>
  </div>

  <ion-grid *ngIf="!isLoading">
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-segment value="dogs" [(ngModel)]="filter" (ionChange)="filterRecipes()" *ngIf="!isFavPage">
          <ion-segment-button value="dogs">
            <ion-label>
              Dogs
            </ion-label>
          </ion-segment-button>
          <ion-segment-button value="cats">
            <ion-label>
              Cats
            </ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-list class="settings-list">
          <div *ngFor="let recipe of loadedRecipes">
            <ion-item detail color="lightmimbo" button="true" [routerLink]="'/recipe/'+recipe.id" class="list-item">
              <img [src]="recipe.image" class="avatar" />
              <div style="padding-bottom: 12px; padding-top: 12px">
                <h1 class="ion-padding-top ion-padding-bottom">
                  {{recipe.name}}<br />
                  <span class="type">{{recipe.type}}</span>
                </h1>
              </div>
              <br />
            </ion-item>
          </div>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>